import { render } from "./AdminNews.vue?vue&type=template&id=78a342f9&scoped=true"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=78a342f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a342f9"]])

export default __exports__